import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import { SelectStringDictionary } from '@models';
import { useStore } from '@stores';

import Presentation from './RoleSelect.presentation';

interface IRoleProps {
  label?: string;
  required?: boolean;
  name?: string;
  onChange?: (values: string[]) => void;
  mode?: 'multiple' | 'tags';
}

export const RoleSelect: React.FC<IRoleProps> = observer(
  ({ onChange, mode, name = "roleNames", label, required }) => {
    const { userStore } = useStore();
    const { roles } = userStore;

    useEffect(() => {
      userStore.getRoles();
    }, [userStore]);

    const options: SelectStringDictionary[] = roles.map((role) => ({
      key: role.id,
      label: role.displayName,
      value: role.name,
    })).filter(x => x.value !== "Admin");

    return (
      <Presentation
        label={label}
        mode={mode}
        required={required}
        name={name}
        onChange={onChange}
        options={options}
      />
    );
  }
);
